import { markRaw } from "vue";
import type { Component } from "vue";

import { TabIcon } from "@/api/http/schemas/borrowerPlatformTemplatesSchemas";

import IconBank from "@/components/icons/tabs/IconBank.vue";
import IconBriefcase from "@/components/icons/tabs/IconBriefcase.vue";
import IconBusiness from "@/components/icons/tabs/IconBusiness.vue";
import IconChat from "@/components/icons/tabs/IconChat.vue";
import IconCheckboard from "@/components/icons/tabs/IconCheckboard.vue";
import IconCreditCard from "@/components/icons/tabs/IconCreditCard.vue";
import IconDocument from "@/components/icons/tabs/IconDocument.vue";
import IconDollar from "@/components/icons/tabs/IconDollar.vue";
import IconGroup from "@/components/icons/tabs/IconGroup.vue";
import IconHandshake from "@/components/icons/tabs/IconHandshake.vue";
import IconHouse from "@/components/icons/tabs/IconHouse.vue";
import IconLayout from "@/components/icons/tabs/IconLayout.vue";
import IconLeter from "@/components/icons/tabs/IconLeter.vue";
import IconLogout from "@/components/icons/tabs/IconLogout.vue";
import IconPiechart from "@/components/icons/tabs/IconPiechart.vue";
import IconProfile from "@/components/icons/IconProfile.vue";
import IconQuestionmark from "@/components/icons/tabs/IconQuestionmark.vue";
import IconWallet from "@/components/icons/tabs/IconWallet.vue";
import IconWeight from "@/components/icons/tabs/IconWeight.vue";
import IconUser from "@/components/icons/tabs/IconUser.vue";

const TAB_ICONS: Record<TabIcon, Component> = {
  [TabIcon.Bank]: markRaw(IconBank),
  [TabIcon.Briefcase]: markRaw(IconBriefcase),
  [TabIcon.Business]: markRaw(IconBusiness),
  [TabIcon.BusinessLoans]: markRaw(IconBusiness),
  [TabIcon.Chat]: markRaw(IconChat),
  [TabIcon.Checkboard]: markRaw(IconCheckboard),
  [TabIcon.CreditCard]: markRaw(IconCreditCard),
  [TabIcon.Document]: markRaw(IconDocument),
  [TabIcon.DocumentText]: markRaw(IconDocument),
  [TabIcon.Documents]: markRaw(IconDocument),
  [TabIcon.Dollar]: markRaw(IconDollar),
  [TabIcon.Faq]: markRaw(IconQuestionmark),
  [TabIcon.Group]: markRaw(IconGroup),
  [TabIcon.Handshake]: markRaw(IconHandshake),
  [TabIcon.House]: markRaw(IconHouse),
  [TabIcon.Layout]: markRaw(IconLayout),
  [TabIcon.Letter]: markRaw(IconLeter),
  [TabIcon.Logout]: markRaw(IconLogout),
  [TabIcon.Piechart]: markRaw(IconPiechart),
  [TabIcon.Profile]: markRaw(IconProfile),
  [TabIcon.Questionmark]: markRaw(IconQuestionmark),
  [TabIcon.User]: markRaw(IconUser),
  [TabIcon.Wallet]: markRaw(IconWallet),
  [TabIcon.Weight]: markRaw(IconWeight),
};

export default TAB_ICONS;
